import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { newsList, newsCategories } from "@/mocks/news";
import { usePageMeta } from "@/hooks/usePageMeta";
import NewsCard from "@/components/feature/NewsCard";

const PAGE_SIZE = 5;

export default function News() {
  const [category, setCategory] = useState("全部");
  const [visible, setVisible] = useState(PAGE_SIZE);

  usePageMeta({
    title: "最新影视资讯 | 国产精品久久",
    description:
      "国产精品久久影视资讯频道汇集最新行业新闻、影视报道与预告速递，为你带来国产影视市场的一手动态与深度观察。",
    keywords: "影视资讯,国产影视新闻,影视报道,影视预告,国产精品久久",
  });

  const filtered = useMemo(
    () => (category === "全部" ? newsList : newsList.filter((n) => n.category === category)),
    [category]
  );

  const shown = filtered.slice(0, visible);

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-8 md:py-10">
      <nav className="flex items-center gap-2 text-sm text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-foreground-800">影视资讯</span>
      </nav>

      <header className="mt-4 border-b border-background-200 pb-5">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          影视资讯
        </h1>
        <p className="mt-2 text-sm text-foreground-600">
          行业新闻、深度报道与最新预告，一站式了解国产影视动态
        </p>
      </header>

      <div className="mt-6 flex flex-wrap items-center gap-1 rounded-full bg-background-100 p-1 w-fit">
        {newsCategories.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => {
              setCategory(item);
              setVisible(PAGE_SIZE);
            }}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
              category === item
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ))}
      </div>

      {shown.length > 0 ? (
        <div className="mt-6 flex flex-col gap-4">
          {shown.map((article) => (
            <NewsCard key={article.id} article={article} variant="list" />
          ))}
        </div>
      ) : (
        <div className="mt-16 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
            <i className="ri-newspaper-line text-3xl" />
          </span>
          <p className="mt-4 text-base font-semibold text-foreground-800">该分类下暂时没有资讯</p>
          <p className="mt-2 text-sm text-foreground-500">看看其他分类，或返回全部资讯</p>
          <button
            type="button"
            onClick={() => {
              setCategory("全部");
              setVisible(PAGE_SIZE);
            }}
            className="mt-6 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            查看全部资讯
          </button>
        </div>
      )}

      {shown.length > 0 && visible < filtered.length && (
        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-8 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            加载更多（剩余 {filtered.length - visible} 条）
          </button>
        </div>
      )}
    </div>
  );
}